import { createInstance } from "i18next";
import ImportBackend from "./importBackend";

export default createInstance({
	fallbackLng: "en",
	language: "en",
	ns: "index",
	defaultNS: "index",
	interpolation: {
		escapeValue: false,
		prefix: "%",
		suffix: "%"
	},
	react: {
		useSuspense: false,
		wait: true,
		bindI18n: "languageChanged loaded",
		bindStore: "added removed",
		nsMode: "default"
	},
	debug: process.env.NODE_ENV !== "production",
}).use(ImportBackend);
